<template>
  <div v-if="departmentIsLoad" class="comp-main" :style="{ width }">
    <div
      :class="{ 'comp-top': true, disabled: !!departmentStaffStr }"
      :title="promptStr"
      @click="toggleDepartment"
    >
      <div class="comp-title">
        <span>{{ departmentActiveStr }}</span>
        <el-link v-if="!departmentStaffStr" class="m-l-10" type="primary">
          {{ toggleStr }}
        </el-link>
      </div>
    </div>
    <div v-if="!departmentStaffStr" v-show="isShowDepartment" class="comp-cont">
      <b-organize-department
        :ids="departmentRouteIds"
        :isInit="!departmentRouteIds.length"
        :bao_han="bao_han"
        @success="getDepartmentActiveList"
      />
      <div style="margin-left: -1px">
        <Staff
          :departmentId="departmentLastId"
          :data.sync="staffActiveObj"
          @hide="hideDepartment"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    Staff: () => import('./staff')
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    bao_han: {
      type: Array,
      default: () => {
        return []
      }
    },
    departmentStaffStr: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: 'auto'
    }
  },
  data() {
    return {
      isShowDepartment: false,
      departmentIsLoad: false,
      departmentLastId: '',
      departmentRouteIds: [],
      departmentActiveList: [],
      staffActiveObj: {}
    }
  },
  computed: {
    // 部门末级选中对象
    departmentLastActiveObj() {
      let result = ''
      let len = this.departmentActiveList.length
      if (len) result = this.departmentActiveList[len - 1]
      return result
    },
    // 部门选中字符串
    departmentActiveStr() {
      let result = ''
      if (this.departmentStaffStr) {
        result = this.departmentStaffStr
      } else {
        let listName = this.departmentActiveList.map((item) => item.name) // 部门
        if (this.staffActiveObj.key) listName.push(this.staffActiveObj.key) // 员工
        result = listName.join('/')
      }
      return result // 部门员工拼接成字符串
    },
    // 切换字符串
    toggleStr() {
      let result = this.isShowDepartment ? '收起↑' : '展开↓'
      return result
    },
    // 提示字符串
    promptStr() {
      let result = `${this.departmentActiveStr}（点击${this.toggleStr}）`
      return result
    },
    // 部门员工选中数据
    departmentStaffActiveData() {
      let result = {
        department_list: this.$util.deepCopy(this.departmentActiveList),
        staff_data: this.$util.deepCopy(this.staffActiveObj)
      }
      return result
    }
  },
  watch: {
    departmentLastActiveObj(newVal, oldVal) {
      if (newVal.id !== oldVal.id) {
        if (newVal.has_children) {
          this.departmentLastId = ''
        } else {
          this.departmentLastId = newVal.id
        }
      }
    },
    departmentStaffActiveData: {
      handler(val) {
        this.$emit('update:data', this.$util.deepCopy(val))
      },
      deep: true
    }
  },
  mounted() {
    this.initDepartmentStaffData()
  },
  methods: {
    // 切换部门
    toggleDepartment() {
      if (this.departmentStaffStr) return
      this.isShowDepartment = !this.isShowDepartment
    },
    // 隐藏部门
    hideDepartment() {
      this.isShowDepartment = false
    },
    // 初始化部门员工数据
    initDepartmentStaffData() {
      this.departmentIsLoad = false
      let idsStr = this.$route.query.ids
      let idsList = []
      if (idsStr) idsList = idsStr.split(',')
      if (idsList.length) {
        this.departmentRouteIds = idsList.map((item) => Number(item))
      }
      if (this.data.department_list && this.data.department_list.length) {
        this.departmentRouteIds = this.data.department_list.map((item) => Number(item.id))
      }
      if (this.data.staff_data) {
        this.staffActiveObj = this.data.staff_data
      }
      this.departmentIsLoad = true
    },
    // 获取选中部门列表
    getDepartmentActiveList(list) {
      this.departmentActiveList = []
      list.forEach((itemSt) => {
        itemSt.category.forEach((itemNd) => {
          if (itemSt.title.active_id === itemNd.id) {
            this.departmentActiveList.push(this.$util.deepCopy(itemNd))
          }
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.comp-main {
  position: relative;
  .comp-top {
    padding: 0 5px;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-sizing: border-box;
    cursor: pointer;
    &.disabled {
      color: @colorGrayC;
      background: @colorGrayF;
      cursor: not-allowed;
      font-size: 12px;
    }
    .comp-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 26px;
    }
  }
  .comp-cont {
    position: absolute;
    top: 33px;
    left: 0;
    display: flex;
  }
}
</style>
